import { useState } from "react";

export const HTMLPreviewModal = ({ html, onClose, onDownload, onCopy }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    onCopy();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={modalOverlay} onClick={onClose}>
      <div style={modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={modalHeader}>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>Generated HTML</h2>
          <button onClick={onClose} style={closeButton}>
            ✕
          </button>
        </div>

        <div style={modalBody}>
          <pre style={codeBlock}>
            <code>{html}</code>
          </pre>
        </div>

        <div style={modalFooter}>
          <button onClick={handleCopy} style={secondaryButton}>
            {copied ? "Copied!" : "Copy to Clipboard"}
          </button>
          <button onClick={onDownload} style={primaryButton}>
            Download HTML
          </button>
        </div>
      </div>
    </div>
  );
};

const modalOverlay: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
  padding: 20,
};

const modalContent: React.CSSProperties = {
  background: "var(--fx-surface-base, #FFFFFF)",
  borderRadius: 12,
  maxWidth: "800px",
  width: "100%",
  maxHeight: "90vh",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
};

const modalHeader: React.CSSProperties = {
  padding: "20px 24px",
  borderBottom: "1px solid var(--fx-surface-border, #E2E8F0)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const modalBody: React.CSSProperties = {
  padding: 24,
  overflowY: "auto",
  flex: 1,
};

const modalFooter: React.CSSProperties = {
  padding: "16px 24px",
  borderTop: "1px solid var(--fx-surface-border, #E2E8F0)",
  display: "flex",
  gap: 12,
  justifyContent: "flex-end",
};

const closeButton: React.CSSProperties = {
  background: "none",
  border: "none",
  fontSize: 24,
  cursor: "pointer",
  color: "var(--fx-surface-textsecondary, #64748B)",
  padding: 4,
  lineHeight: 1,
};

const codeBlock: React.CSSProperties = {
  background: "#1e293b",
  color: "#e2e8f0",
  padding: 20,
  borderRadius: 8,
  overflow: "auto",
  fontSize: 13,
  lineHeight: 1.6,
  fontFamily: "'Monaco', 'Menlo', 'Courier New', monospace",
  margin: 0,
};

const primaryButton: React.CSSProperties = {
  padding: "10px 20px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.2s",
};

const secondaryButton: React.CSSProperties = {
  padding: "10px 20px",
  background: "var(--fx-surface-muted, #F1F5F9)",
  color: "var(--fx-surface-textsecondary, #64748B)",
  border: "1px solid var(--fx-surface-border, #E2E8F0)",
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.2s",
};
